import { DialogContentText as NovaBaseDialogContentText } from '@fme-nova/components'
import { DialogContentText as MuiBaseDialogContentText, DialogContentTextProps, styled } from '@mui/material'

import { createComponentWrapperWithRef } from '../../theme'
import { MsdkStyledComponent } from '../../utils'

const MuiDialogContentText: MsdkStyledComponent<DialogContentTextProps> = styled(MuiBaseDialogContentText)`
  padding-top: 16px;
`

const NovaDialogContentText: MsdkStyledComponent<DialogContentTextProps> = styled(NovaBaseDialogContentText)``

export const DialogContentText = createComponentWrapperWithRef<DialogContentTextProps>(
  {
    mui: MuiDialogContentText,
    nova: NovaDialogContentText,
  },
  'DialogContentText',
)
